export const HOME = {
  startApplication: "home-start-application-btn",
  adminLogin: "home-admin-login-btn",
  heroTitle: "home-hero-title",
};
